module.exports = __webpack_public_path__ + "img/goods.6a8046d6.png";